import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/collapsible'

import { MenuOption } from './menu-option'

interface MenuCollapsible {
  label: string
  sidebarOpen?: boolean
  icon: React.ReactNode
  items: {
    label: string
    path: string
    icon: React.ReactNode
    isDisabled?: boolean
  }[]
  isDesktop?: boolean
  isSheetOpen?: boolean
  handleSheetClose?: () => void
}

export function MenuCollapsible({
  label,
  sidebarOpen,
  icon,
  items,
  isDesktop,
  isSheetOpen,
  handleSheetClose,
}: MenuCollapsible) {
  const [open, setOpen] = useState(false)

  const { pathname } = useLocation()

  const isInsideCollapsible = items?.some(({ path }) => path === pathname)

  return (
    <Collapsible open={open} onOpenChange={setOpen}>
      <CollapsibleTrigger className="w-full">
        <MenuOption
          className={twMerge(
            isInsideCollapsible &&
              'text-monochromatic-500 [&>svg]:text-bios-primary',
          )}
          icon={icon}
          label={label}
          open={open}
          sidebarOpen={sidebarOpen}
          isDesktop={isDesktop}
          isSheetOpen={isSheetOpen}
        />
      </CollapsibleTrigger>
      <CollapsibleContent className="ml-4 border-l-2 border-bios-secondary">
        {items?.map(({ label, path, icon, isDisabled }) => (
          <MenuOption
            handleSheetClose={handleSheetClose}
            isDisabled={isDisabled}
            className={twMerge(!sidebarOpen && 'p-4')}
            key={label}
            path={path}
            icon={icon}
            label={label}
            sidebarOpen={sidebarOpen}
            isDesktop={isDesktop}
            isSheetOpen={isSheetOpen}
          />
        ))}
      </CollapsibleContent>
    </Collapsible>
  )
}
